import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutGallerySlider = {
  factory: EElement({
    id: '8c88e5b6-2d2e-2e34-975e-1afa18ae506b',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('3e85a760-800b-3f69-40c9-db6b715f9bcd')]),
      children: EList([
        EElement({
          id: '5084e419-9bec-5f65-16b5-1710f4d172c4',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'baf0f19b-6ec9-dea9-2047-c06fba2b2ad1',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('916ee694-47ba-1d95-3e1c-70b5cf389d87'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'baf0f19b-6ec9-dea9-2047-c06fba2b2ad2',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            medium: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 2'),
                                gridColumnEnd: EText('span 2'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            tiny: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('2a055616-17e9-1965-216d-9af04ac75fca'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'e56ef745-e3a4-be9e-041b-d60c290ff618',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h3'),
                              children: EList([
                                EElement({
                                  id: 'e56ef745-e3a4-be9e-041b-d60c290ff619',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Slideshow gallery section title goes here'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '641326d5-3689-9431-ad9b-e0f5e76cf095',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              children: EList([
                                EElement({
                                  id: '641326d5-3689-9431-ad9b-e0f5e76cf096',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '4857caff-5ae0-cc26-0afa-a9e89d1b5802',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderWrapper')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          navSpacing: ENumber(3),
                          navShadow: EBoolean(false),
                          autoplay: EBoolean(false),
                          delay: ENumber(4000),
                          iconArrows: EBoolean(true),
                          animation: EEnum('slide'),
                          navNumbers: EBoolean(false),
                          easing: EEnum('ease'),
                          navRound: EBoolean(true),
                          hideArrows: EBoolean(true),
                          disableSwipe: EBoolean(false),
                          duration: ENumber(500),
                          infinite: EBoolean(true),
                          autoMax: ENumber(0),
                          navInvert: EBoolean(false),
                          type: EText('wrapper'),
                        }),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 2'),
                                gridColumnEnd: EText('span 2'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            tiny: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        styleBlockIds: EList([
                          EText('cb1a274f-9cf4-2ebe-6f15-e62c1c6862dd'),
                        ]),
                        children: EList([
                          EElement({
                            id: '4857caff-5ae0-cc26-0afa-a9e89d1b5803',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderMask')
                            ),
                            data: ERecord({
                              slider: ERecord({
                                type: EText('slides'),
                              }),
                              children: EList([
                                EElement({
                                  id: '4857caff-5ae0-cc26-0afa-a9e89d1b5804',
                                  type: qualify(
                                    Plugins.name('Slider'),
                                    Component.name('SliderSlide')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    slider: ERecord({
                                      type: EText('slide'),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'eb2457b0-9acd-ec59-6663-0186781f88fe'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '817ab0b7-0b95-bbdd-7fcc-44c8fde70036',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'c559a660-e372-503d-1964-2f67934161da'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '817ab0b7-0b95-bbdd-7fcc-44c8fde70037',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  src: EText(
                                                    images.placeholderImageSun
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                style: ERecord({
                                                  base: ERecord({
                                                    main: ERecord({
                                                      noPseudo: ERecord({
                                                        gridColumnStart:
                                                          EText('span 1'),
                                                        gridColumnEnd:
                                                          EText('span 1'),
                                                        gridRowStart:
                                                          EText('span 1'),
                                                        gridRowEnd:
                                                          EText('span 1'),
                                                      }),
                                                    }),
                                                  }),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"62796c81b0684e525ff163ea"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8ce3839e-2a35-149b-8c70-921387a656ed'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: '817ab0b7-0b95-bbdd-7fcc-44c8fde70038',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Heading')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('h3'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '95e226fa-a9f9-56d1-530a-b5323bfaf5a9'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '930774ff-97f9-dbb4-6b25-29ca7e78e48a',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Amet minim mollit non deserunt'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '4857caff-5ae0-cc26-0afa-a9e89d1b5805',
                                  type: qualify(
                                    Plugins.name('Slider'),
                                    Component.name('SliderSlide')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    slider: ERecord({
                                      type: EText('slide'),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'eb2457b0-9acd-ec59-6663-0186781f88fe'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '9c6fe6db-2aa1-2112-6660-1271f6e8e539',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'c559a660-e372-503d-1964-2f67934161da'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '9c6fe6db-2aa1-2112-6660-1271f6e8e53a',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  src: EText(
                                                    images.placeholderImageHills
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"62796c81b0684e525ff163da"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8ce3839e-2a35-149b-8c70-921387a656ed'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: '9c6fe6db-2aa1-2112-6660-1271f6e8e53b',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Heading')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('h3'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '95e226fa-a9f9-56d1-530a-b5323bfaf5a9'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '9c6fe6db-2aa1-2112-6660-1271f6e8e53d',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Amet minim mollit non deserunt'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '8b54bd6f-88cc-9fcd-1d84-ea931d01b8ca',
                                  type: qualify(
                                    Plugins.name('Slider'),
                                    Component.name('SliderSlide')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    slider: ERecord({
                                      type: EText('Slider'),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'eb2457b0-9acd-ec59-6663-0186781f88fe'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '4b5c08db-28b1-4333-e204-2364c7c30833',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'c559a660-e372-503d-1964-2f67934161da'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '4b5c08db-28b1-4333-e204-2364c7c30834',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  src: EText(
                                                    images.placeholderImageMountains
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                style: ERecord({
                                                  base: ERecord({
                                                    main: ERecord({
                                                      noPseudo: ERecord({
                                                        gridColumnStart:
                                                          EText('span 1'),
                                                        gridColumnEnd:
                                                          EText('span 1'),
                                                        gridRowStart:
                                                          EText('span 1'),
                                                        gridRowEnd:
                                                          EText('span 1'),
                                                      }),
                                                    }),
                                                  }),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"62796c81b0684e525ff16404"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8ce3839e-2a35-149b-8c70-921387a656ed'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: '4b5c08db-28b1-4333-e204-2364c7c30835',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Heading')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('h3'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '95e226fa-a9f9-56d1-530a-b5323bfaf5a9'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '4b5c08db-28b1-4333-e204-2364c7c30839',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Amet minim mollit non deserunt'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'c8f19e78-fe8b-9131-27fb-79f71ec71b99',
                                  type: qualify(
                                    Plugins.name('Slider'),
                                    Component.name('SliderSlide')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    slider: ERecord({
                                      type: EText('Slider'),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'eb2457b0-9acd-ec59-6663-0186781f88fe'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'e55d8bda-5777-cfb2-4d12-583753fed003',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'c559a660-e372-503d-1964-2f67934161da'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'e55d8bda-5777-cfb2-4d12-583753fed004',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  src: EText(
                                                    images.placeholderImageSun
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                style: ERecord({
                                                  base: ERecord({
                                                    main: ERecord({
                                                      noPseudo: ERecord({
                                                        gridColumnStart:
                                                          EText('span 1'),
                                                        gridColumnEnd:
                                                          EText('span 1'),
                                                        gridRowStart:
                                                          EText('span 1'),
                                                        gridRowEnd:
                                                          EText('span 1'),
                                                      }),
                                                    }),
                                                  }),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"62796c81b0684e525ff163ea"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '8ce3839e-2a35-149b-8c70-921387a656ed'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'e55d8bda-5777-cfb2-4d12-583753fed005',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Heading')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('h3'),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '95e226fa-a9f9-56d1-530a-b5323bfaf5a9'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'e55d8bda-5777-cfb2-4d12-583753fed009',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Amet minim mollit non deserunt'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '4857caff-5ae0-cc26-0afa-a9e89d1b5806',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderArrow')
                            ),
                            data: ERecord({
                              slider: ERecord({
                                dir: EText('left'),
                              }),
                              styleBlockIds: EList([
                                EText('2ca92c1a-657c-df64-d8cc-ce3fe5863358'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '02b8c677-071d-e056-ee31-3380ae5e1132',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'f0f6a58d-b394-7f63-4fc5-39a39a70be3f'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '21504caf-fe44-bfc8-027e-8fc35c336079',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.chevronCircleLeft
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"62796c81b0684e525ff163e3"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              'c2fd480d-3cb7-ef14-5a42-3351be3630c9'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '4857caff-5ae0-cc26-0afa-a9e89d1b5808',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderArrow')
                            ),
                            data: ERecord({
                              slider: ERecord({
                                dir: EText('right'),
                              }),
                              styleBlockIds: EList([
                                EText('fc9ea221-4944-5c87-b283-b9873d721fbb'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'f4d6e7d2-ec6a-6b6c-2c19-286093e43d67',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'f0f6a58d-b394-7f63-4fc5-39a39a70be3f'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '2d3fcc89-a19b-78e8-e9b4-1a29f58e423b',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Image')
                                        ),
                                        data: ERecord({
                                          attr: ERecord({
                                            src: EText(
                                              images.chevronCircleRight
                                            ),
                                            loading: EEnum('lazy'),
                                            width: EText('auto'),
                                            height: EText('auto'),
                                            alt: EText('__wf_reserved_inherit'),
                                          }),
                                          img: ELiteral({
                                            name: qualify(
                                              Plugins.name('Asset'),
                                              typeName('Image')
                                            ),
                                            value: JSON.parse(
                                              '{"id":"62796c81b0684e525ff163cc"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              'c2fd480d-3cb7-ef14-5a42-3351be3630c9'
                                            ),
                                          ]),
                                          temp: ERecord({
                                            img: ERecord({
                                              src: EText(''),
                                            }),
                                          }),
                                          srcsetDisabled: EBoolean(false),
                                          sizes: EList([]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '4857caff-5ae0-cc26-0afa-a9e89d1b580a',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderNav')
                            ),
                            data: ERecord({
                              slider: ERecord({
                                type: EText('nav'),
                              }),
                              styleBlockIds: EList([
                                EText('c9c8b67e-1004-48ef-fa26-75a959da6f0b'),
                              ]),
                              children: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '3e85a760-800b-3f69-40c9-db6b715f9bcd',
      type: 'class',
      name: 'Gallery Slider',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '916ee694-47ba-1d95-3e1c-70b5cf389d87',
      type: 'class',
      name: 'Gallery Wrapper',
      comb: '',
      styleLess:
        'display: grid; align-items: start; grid-auto-columns: 1fr; grid-column-gap: 40px; grid-row-gap: 40px; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'grid-template-columns: 1fr 1fr;'},
        tiny: {styleLess: 'grid-template-columns: 1fr;'},
      },
    },
    {
      _id: '2a055616-17e9-1965-216d-9af04ac75fca',
      type: 'class',
      name: 'Gallery Block',
      comb: '',
      styleLess:
        'display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
      children: [],
      variants: {},
    },
    {
      _id: 'cb1a274f-9cf4-2ebe-6f15-e62c1c6862dd',
      type: 'class',
      name: 'Gallery Slide',
      comb: '',
      styleLess: 'height: auto; background-color: transparent;',
      children: [],
      variants: {small: {styleLess: 'margin-right: 10px; margin-left: 10px;'}},
    },
    {
      _id: 'eb2457b0-9acd-ec59-6663-0186781f88fe',
      type: 'class',
      name: 'Gallery Slide Wrapper',
      comb: '',
      styleLess: 'max-width: 47%; margin-right: 6%;',
      children: [],
      variants: {tiny: {styleLess: 'max-width: 100%; margin-right: 0%;'}},
    },
    {
      _id: 'c559a660-e372-503d-1964-2f67934161da',
      type: 'class',
      name: 'Gallery Slide Image',
      comb: '',
      styleLess: 'position: relative;',
      children: [],
      variants: {},
    },
    {
      _id: '8ce3839e-2a35-149b-8c70-921387a656ed',
      type: 'class',
      name: 'Gallery Image',
      comb: '',
      styleLess: 'width: 100%;',
      children: ['89b50107-cd85-1ac0-949b-4d4b42a224f4'],
      variants: {},
    },
    {
      _id: '95e226fa-a9f9-56d1-530a-b5323bfaf5a9',
      type: 'class',
      name: 'Gallery Slide Text',
      comb: '',
      styleLess:
        'position: absolute; left: 24px; right: 24px; bottom: 24px; margin-bottom: 0px; color: hsla(216, 33.33%, 97.06%, 1.00); line-height: 32px;',
      children: [],
      variants: {small: {styleLess: 'line-height: 30px;'}},
    },
    {
      _id: '2ca92c1a-657c-df64-d8cc-ce3fe5863358',
      type: 'class',
      name: 'Gallery Slider Left',
      comb: '',
      styleLess:
        'left: -50px; display: flex; width: 40px; justify-content: center; align-items: center;',
      children: [],
      variants: {
        medium: {styleLess: 'left: -20px;'},
        tiny: {styleLess: 'left: -20px;'},
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px;',
        },
        small: {styleLess: 'left: -20px;'},
      },
    },
    {
      _id: 'f0f6a58d-b394-7f63-4fc5-39a39a70be3f',
      type: 'class',
      name: 'Arrow Wrapper',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: 'c2fd480d-3cb7-ef14-5a42-3351be3630c9',
      type: 'class',
      name: 'Slider Arrow Embed',
      comb: '',
      styleLess: 'color: #1a1b1f;',
      children: [],
      variants: {},
    },
    {
      _id: 'fc9ea221-4944-5c87-b283-b9873d721fbb',
      type: 'class',
      name: 'Gallery Slider Right',
      comb: '',
      styleLess:
        'right: -50px; display: flex; width: 40px; justify-content: center; align-items: center;',
      children: [],
      variants: {
        medium: {styleLess: 'right: -20px;'},
        tiny: {styleLess: 'right: -20px;'},
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px;',
        },
        small: {styleLess: 'right: -20px;'},
      },
    },
    {
      _id: 'c9c8b67e-1004-48ef-fa26-75a959da6f0b',
      type: 'class',
      name: 'Gallery Slide Nav',
      comb: '',
      styleLess: 'display: none;',
      children: [],
      variants: {},
    },
  ],
} as const;
